import React, { Component } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { connect } from 'react-redux';
import { showError, showMessage, confirmAction } from '../../actions/uiActions';
import PropTypes from 'prop-types';
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Delete from "@mui/icons-material/Delete";
import PictureAsPdf from "@mui/icons-material/PictureAsPdf";
import PictureInPictureAlt from "@mui/icons-material/PictureInPictureAlt";
import Validators from "../../utils/Validators";
import FileUpload from '../../components/FileUpload';
import DomainsApi from '../../api/domains';
import { Tooltip } from '@mui/material';
import { getEmployerAddressFromObject, getEmployerAddressObjectFromString, STATES, toBase64 } from '../../utils/Formatter';

class AuthorizedEntity extends Component {
    constructor() {
        super();
        this.state = {
            employer_name: "",
            employer_fein: "",
            employer_address: {
                street: "",
                city: "",
                state: "",
                zip: ""
            },
            employer_website: "",
            government: false,
            tax_exempt: false,
            emergency_management: false,
            public_education: false,
            public_health: false,
            public_legal_services: false,
            public_library: false,
            public_service_disabilities: false,
            military_service: false,
            law_enforcement: false,
            childhood_education: false,
            school_library: false,
            other_school: false,
            public_safety: false,
            official_name: "",
            official_email: "",
            official_phone: "",
            official_title: "",
            official_remarks: "",
            official_signature: "",
            space_id: "",
            officials: [],
            documents:[]
        }
    }

    componentDidMount() {
        if (this.props.entity) {
            const { employer_address, ...entity } = this.props.entity;
            const updatedState = employer_address ? { 
                    ...entity, 
                    employer_address: getEmployerAddressObjectFromString(employer_address) 
                } : entity;
            this.setState(updatedState);
        }
    }

    handleInputChange = (e) => {
        if(["street", "city", "state", "zip"].includes(e.target.name)){
            this.setState({
                employer_address:{
                    ...this.state.employer_address,
                    [e.target.name]:e.target.value
                }
            });
            return;
        }
        this.setState({ [e.target.name]: e.target.value });
    };

    validateOfficials = () => {
        let hasError = false;
        this.state.officials.forEach((official, index) => {
            if (!hasError) {
                if (!official.official_name) {
                    this.props.showError(`Please enter the Official's Name for the Authorized Official #${index + 2}`);
                    hasError = true;
                } else if (!official.official_title) {
                    this.props.showError(`Please enter the Official's Title for the Authorized Official #${index + 2}`);
                    hasError = true;
                } else if (!Validators.isValidEmail(official.official_email)) {
                    this.props.showError(`Please enter the Official's Email Address for the Authorized Official #${index + 2}`);
                    hasError = true;
                } else if (!official.official_phone) {
                    this.props.showError(`Please enter the Official's Phone Number for the Authorized Official #${index + 2}`);
                    hasError = true;
                } else if (!official.official_remarks) {
                    this.props.showError(`Please enter the Remarks for the Authorized Official #${index + 2}`);
                    hasError = true;
                }
            }
        });
        return !hasError;
    };

    renderEntityForm = () => {
		/*
			Check src/forms/Domain to see how the information about the Entity is collected.
			You will replicate that form here in order to collect the same information.
		*/
        return (
            <div className="row">
                <div className="col-3 offset-1">
                    <div className="form-group nice">
                        <label>Employer name</label>
                        <div className="input-group">
                            <input disabled={this.state.busy} name="employer_name" value={this.state.employer_name}
                                onChange={this.handleInputChange} type="text" className="form-control"
                                placeholder="Employer Name" />
                        </div>
                    </div>
                </div>
                <div className="col-2">
                    <div className="form-group nice">
                        <label>Employer FEIN</label>
                        <div className="input-group">
                            <input disabled={this.state.busy} name="employer_fein" value={this.state.employer_fein}
                                onChange={this.handleInputChange} type="text" className="form-control"
                                placeholder="Employer FEIN" />
                        </div>
                    </div>
                </div>
                <div className="col-5">
                    <div className="form-group nice">
                        <label>Employer Address</label>
                        <div className="input-group">
                            <input 
                                disabled={this.state.busy} 
                                name="street"
                                value={this.state.employer_address.street} 
                                onChange={this.handleInputChange} 
                                type="text"
                                className="form-control" 
                                placeholder="Street Address" 
                            />
                            <input 
                                disabled={this.state.busy} 
                                name="city"
                                value={this.state.employer_address.city} 
                                onChange={this.handleInputChange} 
                                type="text"
                                className="form-control mx-2" 
                                placeholder="City"
                            />

                            <select 
                                disabled={this.state.busy} 
                                name="state"
                                value={this.state.employer_address.state} 
                                onChange={this.handleInputChange} 
                                className="form-control mx-2"
                            >
                                <option value="">{this.state.employer_address.state || "Select State"}</option>
                                {
                                    Object.entries(STATES).map(([abbreviation, name]) => <option key={name} value={abbreviation}>{name}</option>)
                                }
                            </select>
                            <input 
                                disabled={this.state.busy} 
                                name="zip"
                                value={this.state.employer_address.zip} 
                                onChange={this.handleInputChange} 
                                type="text"
                                className="form-control mx-2" 
                                placeholder="Zip code"
                            />

                        </div>
                    </div>
                </div>
                <div className="col-4 offset-1">
                    <div className="form-group nice">
                        <label>Employer Website</label>
                        <div className="input-group">
                            <input disabled={this.state.busy} name="employer_website"
                                value={this.state.employer_website} onChange={this.handleInputChange} type="url"
                                className="form-control" placeholder="Employer Website" />
                        </div>
                    </div>
                </div>
                <div className="col-3">
                    <div className="form-group nice">

                        <FormControlLabel className="inline"
                            control={
                                <Checkbox checked={this.state.government}
                                    onChange={() => this.setState({ government: !this.state.government })}
                                    value="government" />
                            }
                            label="Governmental organization"
                        />
                    </div>
                </div>
                <div className="col-4">
                    <div className="form-group nice">

                        <FormControlLabel className="inline"
                            control={
                                <Checkbox checked={this.state.tax_exempt}
                                    onChange={() => this.setState({ tax_exempt: !this.state.tax_exempt })}
                                    value="tax_exempt" />
                            }
                            label="Tax-exempt under Section 501(c)(3)"
                        />
                    </div>
                </div>
                {!this.state.government && !this.state.tax_exempt && <div className="col-10 offset-1">
                    <div className="form-group nice">
                        <label>Employer Primary Purpose</label>
                        <div className="row">
                            <div className="col-4">
                                <FormControlLabel className="inline simple"
                                    control={
                                        <Checkbox checked={this.state.emergency_management}
                                            onChange={() => this.setState({ emergency_management: !this.state.emergency_management })}
                                            value="emergency_management" />
                                    }
                                    label="Emergency management"
                                />
                            </div>
                            <div className="col-4">
                                <FormControlLabel className="inline simple"
                                    control={
                                        <Checkbox checked={this.state.military_service}
                                            onChange={() => this.setState({ military_service: !this.state.military_service })}
                                            value="military_service" />
                                    }
                                    label="Military service"
                                />
                            </div>
                            <div className="col-4">
                                <FormControlLabel className="inline simple"
                                    control={
                                        <Checkbox checked={this.state.public_safety}
                                            onChange={() => this.setState({ public_safety: !this.state.public_safety })}
                                            value="public_safety" />
                                    }
                                    label="Public safety"
                                />
                            </div>
                            <div className="col-4">
                                <FormControlLabel className="inline simple"
                                    control={
                                        <Checkbox checked={this.state.law_enforcement}
                                            onChange={() => this.setState({ law_enforcement: !this.state.law_enforcement })}
                                            value="law_enforcement" />
                                    }
                                    label="Law enforcement"
                                />
                            </div>
                            <div className="col-4">
                                <FormControlLabel className="inline simple"
                                    control={
                                        <Checkbox checked={this.state.public_legal_services}
                                            onChange={() => this.setState({ public_legal_services: !this.state.public_legal_services })}
                                            value="public_legal_services" />
                                    }
                                    label="Public interest legal services"
                                />
                            </div>
                            <div className="col-4">
                                <FormControlLabel className="inline simple"
                                    control={
                                        <Checkbox checked={this.state.childhood_education}
                                            onChange={() => this.setState({ childhood_education: !this.state.childhood_education })}
                                            value="childhood_education" />
                                    }
                                    label="Early childhood education"
                                />
                            </div>
                            <div className="col-4">
                                <FormControlLabel className="inline simple"
                                    control={
                                        <Checkbox checked={this.state.public_service_disabilities}
                                            onChange={() => this.setState({ public_service_disabilities: !this.state.public_service_disabilities })}
                                            value="public_service_disabilities" />
                                    }
                                    label="Service for individuals with disabilities"
                                />
                            </div>
                            <div className="col-4">
                                <FormControlLabel className="inline simple"
                                    control={
                                        <Checkbox checked={this.state.public_service_elderly}
                                            onChange={() => this.setState({ public_service_elderly: !this.state.public_service_elderly })}
                                            value="public_service_elderly" />
                                    }
                                    label="Public service for the elderly"
                                />
                            </div>
                            <div className="col-4">
                                <FormControlLabel className="inline simple"
                                    control={
                                        <Checkbox checked={this.state.public_health}
                                            onChange={() => this.setState({ public_health: !this.state.public_health })}
                                            value="public_health" />
                                    }
                                    label="Public health"
                                />
                            </div>
                            <div className="col-4">
                                <FormControlLabel className="inline simple"
                                    control={
                                        <Checkbox checked={this.state.public_education}
                                            onChange={() => this.setState({ public_education: !this.state.public_education })}
                                            value="public_education" />
                                    }
                                    label="Public education"
                                />
                            </div>
                            <div className="col-4">
                                <FormControlLabel className="inline simple"
                                    control={
                                        <Checkbox checked={this.state.public_library}
                                            onChange={() => this.setState({ public_library: !this.state.public_library })}
                                            value="public_library" />
                                    }
                                    label="Public library services"
                                />
                            </div>
                            <div className="col-4">
                                <FormControlLabel className="inline simple"
                                    control={
                                        <Checkbox checked={this.state.school_library}
                                            onChange={() => this.setState({ school_library: !this.state.school_library })}
                                            value="school_library" />
                                    }
                                    label="School library services"
                                />
                            </div>
                            <div className="col-4">
                                <FormControlLabel className="inline simple"
                                    control={
                                        <Checkbox checked={this.state.other_school}
                                            onChange={() => this.setState({ other_school: !this.state.other_school })}
                                            value="other_school" />
                                    }
                                    label="Other school-based services"
                                />
                            </div>
                        </div>


                    </div>
                </div>
                }
                {this.renderAttachments()}
                <div className="col-10 offset-1 enclosing-box">
                    <h1>Authorized Official #1</h1>
                    <div className="row contents">
                        <div className="col-6">
                            <div className="form-group nice">
                                <label>Official's Name</label>
                                <div className="input-group">
                                    <input disabled={this.state.busy} name="official_name"
                                        value={this.state.official_name} onChange={this.handleInputChange}
                                        type="text" className="form-control" placeholder="Official's Name" />
                                </div>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group nice">
                                <label>Official's Email</label>
                                <div className="input-group">
                                    <input disabled={this.state.busy} name="official_email"
                                        value={this.state.official_email} onChange={this.handleInputChange}
                                        type="email" className="form-control" placeholder="Official's Email" />
                                </div>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group nice">
                                <label>Official's Phone</label>
                                <div className="input-group">
                                    <input disabled={this.state.busy} name="official_phone"
                                        value={this.state.official_phone} onChange={this.handleInputChange}
                                        type="tel" className="form-control" placeholder="Official's Phone" />
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group nice">
                                <label>Official's Title</label>
                                <div className="input-group">
                                    <input disabled={this.state.busy} name="official_title"
                                        value={this.state.official_title} onChange={this.handleInputChange}
                                        type="text" className="form-control" placeholder="Official's Title" />
                                </div>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group nice">
                                <label>Official's Remarks</label>
                                <div className="input-group">
                                    <input disabled={this.state.busy} name="official_remarks"
                                        value={this.state.official_remarks} onChange={this.handleInputChange}
                                        type="text" className="form-control"
                                        placeholder="Official's Remarks (How can customers identify it)" />
                                </div>
                            </div>
                        </div>
                        <div className='col-3 mt-2'>
                            <label>Employer Signature:</label>
                            <ul className="attachments">
                                {this.state.official_signature && (
                                    <li>
                                        <label><PictureInPictureAlt /> <div>{this.state.official_signature.file_name}</div></label>
                                        <Tooltip title="Delete">
                                            <IconButton onClick={() => this.setState({ official_signature: null })}>
                                                <Delete />
                                            </IconButton>
                                        </Tooltip>
                                    </li>
                                )}
                            </ul>
                            <FileUpload
                                handled={true}
                                onError={this.props.showError}
                                onChange={(file) => {
                                    if (this.validateSelectedFile(file.file)) {
                                        this.setState({ official_signature: file })
                                    }
                        }}
                                disabled={this.state.busy} name="file" accept=".png,.jpg,.jpeg" label="Select Signature File..." />
                        </div>
                    </div>
                </div>
                {this.renderAuthorizedOfficials()}
                <div className="col-10 offset-1">
                    <button onClick={this.addOfficial} className="link">+ Add another Authorized Official</button>
                </div>

            </div>
        );
    };
    handleOfficialInputChange = (e) => {
		const info = e.target.name.split('-');
		this.setState({
			officials: this.state.officials.map(official => {
				if (official.id == info[0])
					official[info[1]] = e.target.value;
				return official;
			})
		})
	}
    renderAuthorizedOfficials = () => {
        return this.state.officials.map((official, index) => <div key={`authorized-official-${index}`}
            className="col-10 offset-1 enclosing-box">

            <h1>Authorized Official #{index + 2}<IconButton aria-label="delete" className="delete"
                onClick={() => this.setState({ officials: this.state.officials.filter(of => of.id != official.id) })}>
                <Delete />
            </IconButton></h1>
            <div className="row contents">
                <div className="col-6">
                    <div className="form-group nice">
                        <label>Official's Name</label>
                        <div className="input-group">
                            <input disabled={this.state.busy} name={`${official.id}-official_name`}
                                value={official.official_name} onChange={this.handleOfficialInputChange}
                                type="text" className="form-control" placeholder="Official's Name" />
                        </div>
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-group nice">
                        <label>Official's Email</label>
                        <div className="input-group">
                            <input disabled={this.state.busy} name={`${official.id}-official_email`}
                                value={official.official_email} onChange={this.handleOfficialInputChange}
                                type="email" className="form-control" placeholder="Official's Email" />
                        </div>
                    </div>
                </div>
                <div className="col-3">
                    <div className="form-group nice">
                        <label>Official's Phone</label>
                        <div className="input-group">
                            <input disabled={this.state.busy} name={`${official.id}-official_phone`}
                                value={official.official_phone} onChange={this.handleOfficialInputChange}
                                type="tel" className="form-control" placeholder="Official's Phone" />
                        </div>
                    </div>
                </div>
                <div className="col-3">
                    <div className="form-group nice">
                        <label>Official's Title</label>
                        <div className="input-group">
                            <input disabled={this.state.busy} name={`${official.id}-official_title`}
                                value={official.official_title} onChange={this.handleOfficialInputChange}
                                type="text" className="form-control" placeholder="Official's Title" />
                        </div>
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-group nice">
                        <label>Official's Remarks</label>
                        <div className="input-group">
                            <input disabled={this.state.busy} name={`${official.id}-official_remarks`}
                                value={official.official_remarks} onChange={this.handleOfficialInputChange}
                                type="text" className="form-control"
                                placeholder="Official's Remarks (How can customers identify it)" />
                        </div>
                    </div>
                </div>

            </div>
        </div>)
    }
    renderAttachments=()=>{
        return <div className="col-10 offset-1">
            <div className="form-group nice">
                <label>Employer PSLF Attachments:</label>
                <div className="row">
                    <div className="col-5">
                    <ul className="attachments">
                    {this.state.documents.map(document=><li key={`document-${document.id}`}>
                    
                    <label><PictureAsPdf /> <div>{document.file_name}</div></label>
                    <Tooltip title="Delete">
                                    <IconButton onClick={()=>this.setState({documents:this.state.documents.filter(d=>d.id!==document.id)})}>
                                        <Delete />
                                    </IconButton>
                                </Tooltip>
                       
                    </li>)}
                </ul>
                <FileUpload handled={true} onError={this.props.showError} onUpload={DomainsApi.uploadDocument} onChange={(file)=>this.setState({documents:[
                    ...this.state.documents,
                    {
                        id:Date.now(),
                        uploaded:true,
                        ...file
                    }
                ]})} disabled={this.state.busy} name="file" accept=".pdf" label="Select File..." />
                    </div>
                </div>
                
            </div>
        </div>
        
    }
    addOfficial = () => {
        this.setState({
            officials: [...this.state.officials, {
                id: Date.now(),
                official_name: "",
                official_email: "",
                official_phone: "",
                official_title: "",
                official_remarks: ""
            }]
        })
    };

    validateSelectedFile = (file) => {
        if (file) {
            const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
            const maxSize = 50 * 1024;
            if (!allowedTypes.includes(file.type)) {
                this.props.showError('Invalid file type. Only JPEG, PNG files are allowed.');
                return
            } else if (file.size > maxSize) {
                this.props.showError('File size exceeds 50KB.');
                return
            } else {
                return true
            }
        }
    }

    
    save = async () => {
        //Validate the user input
        if (!this.state.employer_name)
            this.props.showError("Please enter the Employer Name");
        else if (!this.state.employer_fein)
            this.props.showError("Please enter the Employer FEIN");
        else if (
            !this.state.employer_address.street || 
            !this.state.employer_address.city || 
            !this.state.employer_address.state || 
            !this.state.employer_address.zip
        )
                this.props.showError("Please enter the Employer's Street, City, State and Zip code");
        else if (!this.state.official_title)
            this.props.showError("Please enter the Official's Title");
        else if (!Validators.isValidEmail(this.state.official_email))
            this.props.showError("Please enter the Official's Email Address");
        else if (!this.state.official_phone)
            this.props.showError("Please enter the Official's Phone Number");
        else if (this.state.officials.length > 0 && !this.state.official_remarks)
            this.props.showError("When you have more than on Authorized Official, you must provide remarks for each of them so the customers can identify them.");
        else if (this.state.officials.length > 0 && !this.validateOfficials()) {
            return;
        } else if (
            !this.state.government &&
            !this.state.tax_exempt &&
            !this.state.public_education &&
            !this.state.public_health &&
            !this.state.public_service_disabilities &&
            !this.state.public_legal_services &&
            !this.state.public_library &&
            !this.state.public_safety &&
            !this.state.public_service_elderly &&
            !this.state.law_enforcement &&
            !this.state.childhood_education &&
            !this.state.school_library &&
            !this.state.other_school &&
            !this.state.military_service &&
            !this.state.emergency_management
        )
            this.props.showError("Please select the Employer main purpose");
        else {
            //No need to modify the code below
            let official_signature_file
            if (this.state.official_signature && this.validateSelectedFile(this.state.official_signature.file)) {
                official_signature_file = await toBase64(this.state.official_signature.file);
            }
            if (this.props.entity) {
                this.props.onEntityUpdated({
                    id:this.props.entity.id,
                    ...this.state,
                    official_signature: official_signature_file,
                    employer_address: getEmployerAddressFromObject(this.state.employer_address)
                });
            } else {
                this.props.onEntityCreated({
                    ...this.state, 
                    official_signature: official_signature_file,
                    employer_address: getEmployerAddressFromObject(this.state.employer_address)
                });
            }
        }
    };

    render() {
        return <Dialog fullWidth={true} maxWidth="xl"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description" open={true} fullScreen={true}
        >
            <DialogTitle id="alert-dialog-title">{this.props.entity ? "Edit" : "Add"} Employer</DialogTitle>
            <DialogContent>
                {this.renderEntityForm()}
            </DialogContent>
            {!this.state.busy && <DialogActions>

                <Button variant="outlined" onClick={this.save} color="primary" autoFocus>
                    {this.props.edit ? "Update" : "Add"} Entity
				</Button>
                <Button onClick={this.props.onClose} color="primary">
                    Cancel
				</Button>
            </DialogActions>}
        </Dialog>;
    }
}

AuthorizedEntity.propTypes = {
    entity: PropTypes.object,
    edit: PropTypes.bool,
    onClose: PropTypes.func,
    onEntityUpdated: PropTypes.func,
    onEntityCreated: PropTypes.func,
    id: PropTypes.string
};


export default connect(null, { showError, showMessage, confirmAction })(AuthorizedEntity);
